import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getDetail = async (params: object) => {
  return await GET({ url: Api.getDetail, params, showError: false })
}
